/* eslint-disable import/prefer-default-export */
import React from "react";
import styled from "styled-components";

import BottomNavigation from "../../components/BottomNavigation";
import { getTabBarTotalHeight } from "../../constants/tabBarLayout";

const tabBarBottomClearance = getTabBarTotalHeight();

const Shell = styled.div`
  width: 100%;
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
  overflow: hidden;
  position: relative;
`;

const MapArea = styled.div`
  flex: 1;
  position: relative;
  min-height: 0;
  padding-bottom: var(--tab-bar-clearance, ${tabBarBottomClearance}px);
  box-sizing: border-box;
`;

type MapLayoutProps = {
  children: React.ReactNode;
};

export function MapLayout({ children }: MapLayoutProps) {
  return (
    <Shell>
      <MapArea>{children}</MapArea>
      <BottomNavigation />
    </Shell>
  );
}
